import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Plus = (props: IconProps) => (
  <Icon
    width='8'
    height='8'
    viewBox='0 0 8 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M4 1L4 7' strokeLinecap='round' />
    <path d='M7 4L1 4' strokeLinecap='round' />
  </Icon>
);
